import React from 'react';
import Careers from '../Components/InfoPages/Careers';

function CareersPage() {
  return <Careers />;
}

export default CareersPage;
